import { create } from 'zustand';
import { CreditCard } from '@/types/card';
import { GermanCompareCard } from '@/types/cardDE';

// Union type to support both Norwegian and German cards
type CompareCard = CreditCard | GermanCompareCard;

interface ComparisonStore {
  selectedCards: CompareCard[];
  addCard: (card: CompareCard) => void;
  removeCard: (cardId: string) => void;
  clearAll: () => void;
  isSelected: (cardId: string) => boolean;
}

export const useComparison = create<ComparisonStore>((set, get) => ({
  selectedCards: [],
  addCard: (card) => {
    const current = get().selectedCards;
    if (current.length >= 3) return; // Max 3 cards
    set({ selectedCards: [...current, card] });
  },
  removeCard: (cardId) => {
    set({ selectedCards: get().selectedCards.filter(c => c.id !== cardId) });
  },
  clearAll: () => set({ selectedCards: [] }),
  isSelected: (cardId) => get().selectedCards.some(c => c.id === cardId),
}));
